import React from "react";
import CommonRow from "../common-row";

const FourStories = props => {
  return <CommonRow {...props} />;
};

export default FourStories;
